import { AdminApp } from '../admin/AdminApp';
import { ContentPage } from '../public/pages/ContentPage';
import { HomePage } from '../public/pages/HomePage';

export function CurrentRoute() {
  const path = window.location.pathname;

  if (path === '/' || path === '/home') {
    return <HomePage />;
  }

  if (path.startsWith('/admin')) {
    return <AdminApp />;
  }

  if (path === '/about') {
    return <ContentPage slug="about" />;
  }

  if (path.startsWith('/pages/')) {
    return <ContentPage slug={path.replace('/pages/', '')} />;
  }

  return <HomePage />;
}
